(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;

  // shop.money_format n'est pas toujours {{amount}} : une boutique francaise utilise
  // le plus souvent {{amount_with_comma_separator}}. Ne traiter que la premiere forme
  // laissait le gabarit brut a l'ecran. On gere les cinq placeholders de Shopify.
  function groupe(entier, separateur) {
    return entier.replace(/\B(?=(\d{3})+(?!\d))/g, separateur);
  }

  function money(cents) {
    var format = document.documentElement.dataset.moneyFormat || '{{amount}}';
    var valeur = Math.round(cents) / 100;

    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, nom) {
      var decimales = nom.indexOf('no_decimals') === -1 ? 2 : 0;
      var fixe = valeur.toFixed(decimales);
      var parts = fixe.split('.');
      var milliers = ',';
      var decimal = '.';

      if (nom.indexOf('comma_separator') !== -1) {
        milliers = '.';
        decimal = ',';
      } else if (nom.indexOf('apostrophe_separator') !== -1) {
        milliers = "'";
      }

      var out = groupe(parts[0], milliers);
      if (parts.length > 1) out += decimal + parts[1];
      return out;
    });
  }

  function announce(message) {
    var live = document.querySelector('[data-cart-live]');
    if (live) live.textContent = message;
  }

  function setBusy(state) {
    busy = state;
    document.querySelectorAll('[data-cart-busy]').forEach(function (node) {
      node.toggleAttribute('disabled', state);
    });
  }

  function request(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok) throw payload;
        return payload;
      });
    });
  }

  function renderSections() {
    var mainCart = document.querySelector('[data-cart-section-id]');
    var names = ['cart-drawer'];
    if (mainCart) names.push(mainCart.dataset.cartSectionId);

    return fetch(root + '?sections=' + names.join(','))
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var parser = new DOMParser();

        if (data['cart-drawer']) {
          var freshDrawer = parser.parseFromString(data['cart-drawer'], 'text/html').querySelector('[data-drawer-body]');
          var currentDrawer = document.querySelector('[data-drawer-body]');
          if (freshDrawer && currentDrawer) currentDrawer.innerHTML = freshDrawer.innerHTML;
        }

        if (mainCart && data[mainCart.dataset.cartSectionId]) {
          var freshMain = parser
            .parseFromString(data[mainCart.dataset.cartSectionId], 'text/html')
            .querySelector('[data-cart-section-id]');
          if (freshMain) mainCart.innerHTML = freshMain.innerHTML;
        }
      });
  }

  function updateCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = cart.item_count;
    });
  }

  function openDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || typeof drawer.showModal !== 'function') return;
    if (!drawer.open) drawer.showModal();
    if (window.GIGI && window.GIGI.hostCursor) window.GIGI.hostCursor(drawer);
  }

  function closeDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer && drawer.open) drawer.close();
    if (window.GIGI && window.GIGI.hostCursor) window.GIGI.hostCursor(null);
  }

  document.addEventListener('click', function (event) {
    var drawer = event.target;
    if (!drawer.matches || !drawer.matches('[data-cart-drawer]')) return;
    // La cible n'est le <dialog> que si le clic a eu lieu sur son ::backdrop :
    // tout clic dans le panneau a pour cible un descendant.
    closeDrawer();
  });

  document.addEventListener('close', function (event) {
    if (event.target.matches('[data-cart-drawer]')) {
      if (window.GIGI && window.GIGI.hostCursor) window.GIGI.hostCursor(null);
    }
  }, true);

  function add(formData) {
    if (busy) return Promise.resolve();
    setBusy(true);

    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok) throw payload;
          return payload;
        });
      })
      .then(function (item) {
        announce(item.title + ' — ' + (document.documentElement.dataset.cartAdded || ''));
        return refresh().then(openDrawer);
      })
      .catch(function (error) {
        announce((error && error.description) || '');
      })
      .finally(function () {
        setBusy(false);
      });
  }

  function change(line, quantity) {
    if (busy) return Promise.resolve();
    setBusy(true);

    return request(root + 'cart/change.js', { line: line, quantity: quantity })
      .then(function (cart) {
        updateCount(cart);
        return renderSections();
      })
      .catch(function (error) {
        announce((error && error.description) || '');
      })
      .finally(function () {
        setBusy(false);
      });
  }

  function clear() {
    if (busy) return Promise.resolve();
    setBusy(true);

    return request(root + 'cart/clear.js', {})
      .then(function (cart) {
        updateCount(cart);
        return renderSections();
      })
      .catch(function (error) {
        announce((error && error.description) || '');
      })
      .finally(function () {
        setBusy(false);
      });
  }

  function refresh() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateCount(cart);
        return renderSections();
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('[data-add-to-cart], #ProductForm')) return;
    if (!window.fetch) return;
    event.preventDefault();
    add(new FormData(form));
  });

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    var opener = target.closest('[data-cart-open]');
    if (opener && document.querySelector('[data-cart-drawer]')) {
      event.preventDefault();
      openDrawer();
      return;
    }

    if (target.closest('[data-cart-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var stepper = target.closest('[data-cart-step]');
    if (stepper) {
      event.preventDefault();
      var line = Number(stepper.dataset.line);
      var next = Number(stepper.dataset.cartStep);
      change(line, next);
      return;
    }

    var remove = target.closest('[data-cart-remove]');
    if (remove) {
      event.preventDefault();
      change(Number(remove.dataset.line), 0);
      return;
    }

    if (target.closest('[data-cart-clear]')) {
      event.preventDefault();
      clear();
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches('[data-cart-quantity]')) return;
    var quantity = Math.max(0, parseInt(input.value, 10) || 0);
    change(Number(input.dataset.line), quantity);
  });

  window.GigiCart = {
    add: add,
    change: change,
    clear: clear,
    refresh: refresh,
    open: openDrawer,
    close: closeDrawer,
    money: money
  };
})();
